
import React from "react";

function Projetos() {
  return (
    <section id="projetos" className="secao projetos">
      <div className="container">
        <div className="projetos-painel">
          <div className="projetos-conteudo">
            <span className="sobretitulo sobretitulo-claro">
              SEU PRÓXIMO PROJETO COMEÇA AQUI
            </span>

            <h2>
              Sua necessidade é única.
              <br />
              <span>Nossa solução também.</span>
            </h2>

            <p>
              Não trabalhamos com soluções engessadas ou uma tabela
              única de preços. Entendemos seu objetivo, avaliamos a
              complexidade do projeto e elaboramos uma proposta
              personalizada para sua empresa.
            </p>

            <a href="#contato" className="btn-projeto">
              Vamos conversar sobre sua ideia
              <span aria-hidden="true"> ↗</span>
            </a>

            <span className="projetos-observacao">
              Sem compromisso. Vamos começar entendendo o que você precisa.
            </span>
          </div>

          <div className="projetos-visual" aria-hidden="true">
            <div className="projetos-circulo projetos-circulo-1" />
            <div className="projetos-circulo projetos-circulo-2" />

            <div className="projetos-simbolo">
              <span>{"<"}</span>
              <i className="fas fa-code" />
              <span>{"/>"}</span>
            </div>

            <div className="projetos-etiqueta projetos-etiqueta-1">
              <i className="fas fa-check-circle" />
              Solução personalizada
            </div>

            <div className="projetos-etiqueta projetos-etiqueta-2">
              <i className="fas fa-lightbulb" />
              Sua ideia, nosso projeto
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projetos;
